/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCountryCodes_countryCodes_CountryCode = { readonly __typename: 'CountryCode', readonly displayName: string, readonly isoCode2: string };

export type GetCountryCodes_Query = { readonly __typename: 'Query', readonly countryCodes: ReadonlyArray<GetCountryCodes_countryCodes_CountryCode> };


export type GetCountryCodesVariables = _Types.Exact<{ [key: string]: never; }>;


export type GetCountryCodes = GetCountryCodes_Query;


export const GetCountryCodesDocument = gql`
    query GetCountryCodes {
  countryCodes {
    displayName
    isoCode2
  }
}
    `;

/**
 * __useGetCountryCodes__
 *
 * To run a query within a React component, call `useGetCountryCodes` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryCodes` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryCodes({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryCodes(baseOptions?: Apollo.QueryHookOptions<GetCountryCodes, GetCountryCodesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryCodes, GetCountryCodesVariables>(GetCountryCodesDocument, options);
      }
export function useGetCountryCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryCodes, GetCountryCodesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryCodes, GetCountryCodesVariables>(GetCountryCodesDocument, options);
        }
export function useGetCountryCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryCodes, GetCountryCodesVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountryCodes, GetCountryCodesVariables>(GetCountryCodesDocument, options);
        }
export type GetCountryCodesHookResult = ReturnType<typeof useGetCountryCodes>;
export type GetCountryCodesLazyQueryHookResult = ReturnType<typeof useGetCountryCodesLazyQuery>;
export type GetCountryCodesSuspenseQueryHookResult = ReturnType<typeof useGetCountryCodesSuspenseQuery>;
export type GetCountryCodesQueryResult = Apollo.QueryResult<GetCountryCodes, GetCountryCodesVariables>;